import React from "react";
import Coordinate from "../Coordinate/Coordinate";
import { BOLMediaPurpose, InspectionType } from "../../utils/enums";
import "./style.css";

const PhotoFooter = ({ inspectionType, photo }) => {
  const showPowerUnitLabel =
    photo.purpose === BOLMediaPurpose.PowerUnit &&
    inspectionType === InspectionType.Pickup;

  return (
    <div className="photo-footer">
      {showPowerUnitLabel ? (
        <span className="photo-purpose-text">Power Unit</span>
      ) : (
        <div />
      )}

      <Coordinate latitude={photo.latitude} longitude={photo.longitude} />
    </div>
  );
};

export default PhotoFooter;
